import React, { useRef } from "react";
import emailjs from "emailjs-com";
import { Form, Button } from "react-bootstrap";

function ContactForm() {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_q73ictk",       // ✅ Your Gmail Service ID
        "template_2yfft6x",      // ✅ Your Template ID
        form.current,
        "LMRH2W8Rndnn_W1Jd"      // ✅ Your Public Key
      )
      .then(
        () => {
          alert("Message sent!");
          form.current.reset(); // clear the form after success
        },
        () => {
          alert("Something went wrong. Please try again.");
        }
      );
  };

  return (
    <Form
      ref={form}
      onSubmit={sendEmail}
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "1rem",
        maxWidth: "600px",
        margin: "0 auto",
      }}
    >
      <Form.Group controlId="formName">
        <Form.Label>Name</Form.Label>
        <Form.Control type="text" name="user_name" placeholder="Your name" required />
      </Form.Group>

      <Form.Group controlId="formEmail">
        <Form.Label>Email</Form.Label>
        <Form.Control type="email" name="user_email" placeholder="you@example.com" required />
      </Form.Group>

      <Form.Group controlId="formMessage">
        <Form.Label>Message</Form.Label>
        <Form.Control
          as="textarea"
          rows={4}
          name="message"
          placeholder="Type your message here"
          required
        />
      </Form.Group>

      <Button variant="primary" type="submit" style={{ alignSelf: "flex-start" }}>
        SEND
      </Button>
    </Form>
  );
}

export default ContactForm;
